<span [class]="column.headerCellClass" [title]="column.headerTooltipText">
    <span *ngIf="column.headerIconClass" class="{{ column.headerIconClass }} icon-left"> </span>
    <span>
        {{ column.title }}
    </span>
</span>
